import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { api } from "../../config";
import { I } from "../../Components/CMI/icons";
import logo from "../../assets/cmi/logo_CE.png";

const Login = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const f = useFormik({
    enableReinitialize: true,
    initialValues: { email: "", password: "" },
    validationSchema: Yup.object({
      email: Yup.string().required("Por favor ingrese su email"),
      password: Yup.string().required("Por favor ingrese su contraseña"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setErrorMsg(null);
      try {
        const res = await axios.post(`${api.API_URL}/auth/login`, values);
        // api_helper unwraps response.data; res is already the body
        if (!res || !res.token || !res.user) throw new Error("Respuesta del servidor inválida");
        sessionStorage.setItem("authUser", JSON.stringify({ user: res.user, token: res.token }));
        navigate("/dashboard-finanzas");
      } catch (err) {
        const m = typeof err === "string" ? err
          : err?.response?.data?.error || err?.response?.data?.message
          || err?.message || "Credenciales incorrectas";
        setErrorMsg(m);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => { if (errorMsg) { const t = setTimeout(() => setErrorMsg(null), 4500); return () => clearTimeout(t); } }, [errorMsg]);

  document.title = "Iniciar Sesión | CMI";

  const inputStyle = {
    width: "100%", height: 44, borderRadius: 10,
    border: "1px solid var(--ce-border)",
    background: "var(--ce-surface)",
    padding: "0 14px 0 40px",
    fontFamily: "var(--ce-font-sans)", fontSize: 14, color: "var(--ce-fg)",
    outline: "none", boxShadow: "var(--ce-shadow-xs)",
  };
  const errBorder = (touched, err) => touched && err
    ? { borderColor: "var(--ce-danger)", boxShadow: "0 0 0 3px rgba(239,68,68,0.18)" }
    : {};

  return (
    <div className="cmi-app" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, position: "relative", overflow: "hidden" }}>
      <div aria-hidden style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 0 }}>
        <div style={{ position: "absolute", top: -200, left: "10%", width: 600, height: 600, background: "radial-gradient(circle, var(--ce-primary-soft) 0%, transparent 60%)", opacity: 0.7 }} />
        <div style={{ position: "absolute", bottom: -200, right: "10%", width: 500, height: 500, background: "radial-gradient(circle, var(--ce-cyan-soft) 0%, transparent 60%)", opacity: 0.5 }} />
      </div>

      <div style={{ position: "relative", zIndex: 1, width: "100%", maxWidth: 420 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img src={logo} alt="Cucalón Estévez" style={{ height: 56, marginBottom: 16 }} />
          <h1 style={{ margin: 0, fontFamily: "var(--ce-font-display)", fontSize: 24, fontWeight: 600, color: "var(--ce-fg)", letterSpacing: "-0.02em" }}>
            Cuadro de Mando Integral
          </h1>
          <p style={{ marginTop: 6, color: "var(--ce-fg-muted)", fontSize: 13 }}>
            Acceso restringido al equipo del Grupo Cucalón Estévez
          </p>
        </div>

        <div className="cd" style={{ padding: "32px 28px" }}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: "var(--ce-fg)", fontFamily: "var(--ce-font-display)", letterSpacing: "-0.01em" }}>
            Inicia sesión
          </h2>
          <p style={{ margin: "4px 0 24px", fontSize: 13, color: "var(--ce-fg-muted)" }}>
            Usa tus credenciales del ERP.
          </p>

          {errorMsg && (
            <div className="alert err" style={{ marginBottom: 18 }}>
              <I.Triangle size={18} />
              <div className="body">
                <div className="txt">{errorMsg}</div>
              </div>
            </div>
          )}

          <form onSubmit={(e) => { e.preventDefault(); f.handleSubmit(); }}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 500, color: "var(--ce-fg-muted)", marginBottom: 6 }}>Email</label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "var(--ce-fg-faint)" }}>
                  <I.Mail size={16}/>
                </span>
                <input
                  name="email" type="email" autoComplete="email"
                  placeholder="usuario@empresa.com"
                  value={f.values.email}
                  onChange={f.handleChange} onBlur={f.handleBlur}
                  style={{ ...inputStyle, ...errBorder(f.touched.email, f.errors.email) }}
                />
              </div>
              {f.touched.email && f.errors.email && (
                <div style={{ marginTop: 4, fontSize: 11, color: "var(--ce-red-ink)" }}>{f.errors.email}</div>
              )}
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 500, color: "var(--ce-fg-muted)", marginBottom: 6 }}>Contraseña</label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "var(--ce-fg-faint)" }}>
                  <I.Lock size={16}/>
                </span>
                <input
                  name="password" type={show ? "text" : "password"} autoComplete="current-password"
                  placeholder="••••••••"
                  value={f.values.password}
                  onChange={f.handleChange} onBlur={f.handleBlur}
                  style={{ ...inputStyle, paddingRight: 44, ...errBorder(f.touched.password, f.errors.password) }}
                />
                <button type="button" onClick={() => setShow((s) => !s)}
                  style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", width: 32, height: 32, border: 0, background: "transparent", cursor: "pointer", color: "var(--ce-fg-muted)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                  {show ? <I.EyeOff size={16}/> : <I.Eye size={16}/>}
                </button>
              </div>
              {f.touched.password && f.errors.password && (
                <div style={{ marginTop: 4, fontSize: 11, color: "var(--ce-red-ink)" }}>{f.errors.password}</div>
              )}
            </div>

            <button type="submit" disabled={loading} className="btn btn-pri" style={{ width: "100%", height: 44, fontSize: 14, justifyContent: "center" }}>
              {loading ? (<><span className="spinner" /> Verificando…</>) : (<><I.ArrowRight size={16}/> Iniciar sesión</>)}
            </button>
          </form>

          <div style={{ marginTop: 20, textAlign: "center", fontSize: 11, color: "var(--ce-fg-faint)" }}>
            <I.Shield size={12} style={{ verticalAlign: "middle", marginRight: 4 }}/>
            Acceso seguro · JWT
          </div>
        </div>

        <p style={{ marginTop: 18, textAlign: "center", fontSize: 11, color: "var(--ce-fg-faint)" }}>
          Visados Empresas · Permiso de Trabajo · CVS
        </p>
      </div>
    </div>
  );
};

export default Login;
